import { REGIONS } from './region';
class RegionService {
    isValidRegion(region) {
        if (!region)
            return false;
        const normalizedRegion = region.toLowerCase();
        return Object.keys(REGIONS).includes(normalizedRegion);
    }
    isUSRegion(region) {
        if (!region)
            return false;
        return region.toUpperCase() === REGIONS.us;
    }
    getAllRegions() {
        return REGIONS;
    }
    getRegionCode(key) {
        if (!key)
            return undefined;
        const normalizedKey = key.toLowerCase();
        return REGIONS[normalizedKey];
    }
}
export const regionService = new RegionService();
